module.exports = __webpack_public_path__ + "static/media/23.f26d833a.svg";